import { Injectable } from "@angular/core";
import { IVehicleData } from "../models/vehicle-data.model";
import { BehaviorSubject, Observable, of } from "rxjs";

@Injectable({
    providedIn: 'root'
  })

export class DataManagmentService {

    private vehicleDataSubject = new BehaviorSubject<IVehicleData | null>(this.getStoredVehicleData());

    setVehicleData(data: IVehicleData): void {
      this.vehicleDataSubject.next(data);
      localStorage.setItem('vehicleData', JSON.stringify(data));
    }
    
    getVehicleData(): Observable<IVehicleData | null> {
      return this.vehicleDataSubject.asObservable();
    }
    
    private getStoredVehicleData(): IVehicleData | null {
      const stored = localStorage.getItem('vehicleData');
      return stored ? JSON.parse(stored) : null;
    }
    

}
